'use client'

import styled from 'styled-components'

import { TypeStyle } from '@syconium/little-miss-figgy'

export const EmbroideryTitle = styled.span`
  ${TypeStyle.css.headlineExtraExtraSmall};
  font-size: 13px;
  font-weight: 700;
`

export const EmbroiderySectionSubtotal = styled(TypeStyle.HeadlineExtraExtraSmall).attrs({
  as: 'span',
})`
  color: ${o => o.theme.color.stroke.neutral.text.tertiary.on.background};
  font-size: 13px;
  font-weight: 600;
`
